export class ChartSerie {
    public name: string;
    public stack: string;
    public type: string;
    public color: string;
    public data: any[] = [];
    public dashStyle: string;
    public lineWidth: number;
    public serieTotal: number;
    public serieAverage: number;
    public serieMedian: number;
    public turboThreshold: number = 0;
    public showInLegend: boolean;
    public yAxis: number = 0;
    public zIndex: number;
}
